
import { Vue, Component, Prop } from 'vue-property-decorator';
import { Popover } from 'element-ui';
import { IFileCheck } from '@/types/question.d';

/* eslint-disable dot-notation */
/* eslint-disable global-require */
@Component({
  components: {
    Popover,
  },
})
export default class QuestionBox extends Vue {
  private cover: string | null = '';

  private nameError: boolean = false;

  private imgUrls: { [key: string]: string } = {
    loveImgUrl: require('../icon/loveImg.png'),
  };

  @Prop() boxConfig!: IFileCheck;

  @Prop() validate?: boolean;

  @Prop() operate?: boolean;

  @Prop() select?: string;

  mounted() {
    if (this.boxConfig.status !== 'md5Exist' && this.boxConfig.errors.length > 0) this.nameError = true;
    if (this.boxConfig.imgUrl) this.cover = this.boxConfig.imgUrl;
    if (this.boxConfig.file) {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(this.boxConfig.file);
      fileReader.onloadend = (res: ProgressEvent) => {
        this.cover = res.target && (res.target as FileReader).result as string;
      };
    }
  }

  /**
   * @author Terry
   * @description 修改Input的Change事件
   * @param { InputEvent } value
   */
  handleTextChange(value: InputEvent) {
    this.$emit('handleTextChange', { md5: this.boxConfig.md5, value: value.target && (value.target as any).value });
  }

  /**
   * @author Terry
   * @description 处理选中点击事件
   */
  handleCheck() {
    this.$emit('handleCheck', {
      pid: this.boxConfig.pid,
      flag: this.select === 'check' ? 'uncheck' : 'check',
    });
  }
}
